// document.addEventListener("DOMContentLoaded", function () {
//   const continueBtn = document.getElementById("continue-to-cart");
//   const loader = document.getElementById("format-initial-loader");

//   function dataURLtoBlob(dataurl) {
//     const arr = dataurl.split(",");
//     const mime = arr[0].match(/:(.*?);/)[1];
//     const bstr = atob(arr[1]);
//     let n = bstr.length;
//     const u8arr = new Uint8Array(n);
//     while (n--) u8arr[n] = bstr.charCodeAt(n);
//     return new Blob([u8arr], { type: mime });
//   }

//   function buildFormData() {
//     const selectedFormat = document.querySelector(
//       'input[name="book-format"]:checked'
//     ).value;
//     const selectedGender = localStorage.getItem("selectedGender");
//     const childName = localStorage.getItem("childName");
//     const customText = localStorage.getItem("customMessage");
//     const dataURL = localStorage.getItem("uploadedImageDataURL");

//     // if (!dataURL) {
//     //   console.warn("No uploaded image found in localStorage");
//     //   return null;
//     // }

//     // const blob = dataURLtoBlob(dataURL);
//     // const imageFile = new File([blob], "photo.png", { type: "image/png" });

//     const formData = new FormData();
//     formData.append("firstName", childName || "");
//     formData.append("gender", (selectedGender || "BOY").toUpperCase());
//     formData.append("customText", customText || "");
//     formData.append(
//       "coverType",
//       selectedFormat === "premium" ? "HARD" : "SOFT"
//     );
//     if (dataURL) {
//       const blob = dataURLtoBlob(dataURL);
//       const imageFile = new File([blob], "photo.png", { type: "image/png" });
//       formData.append("image", imageFile);
//     }
//     // formData.append("image", imageFile);
//     return formData;
//   }

//   continueBtn?.addEventListener("click", function () {
//     const selectedFormat = document.querySelector(
//       'input[name="book-format"]:checked'
//     ).value;
//     const isPhotoUploaded = localStorage.getItem("photoUploaded") === "true";
//     const dataURL = isPhotoUploaded
//       ? localStorage.getItem("uploadedImageDataURL")
//       : null;

//     const formData = isPhotoUploaded ? buildFormData() : null;

//     // const firebaseCoverPdfLink =
//     //   selectedFormat === "premium"
//     //     ? localStorage.getItem("firebasePremiumCoverPdfLink")
//     //     : localStorage.getItem("firebaseStandardCoverPdfLink");

//     // const firebaseContentPdfLink = localStorage.getItem(
//     //   "firebaseContentPdfLink"
//     // );

//     const standardVariantId = 51048141783386;
//     const premiumVariantId = 51048141816154;
//     const photoAddonVariantId = 51048547189082;

//     const selectedVariantId =
//       selectedFormat === "premium" ? premiumVariantId : standardVariantId;

//     const lineProperties = {
//       "Selected Format":
//         selectedFormat === "premium"
//           ? "Premium Cover (£45)"
//           : "Standard Book (£35)",
//     };

//     if (isPhotoUploaded) {
//       lineProperties["Photo Upload"] = "Yes (+£3.00)";
//     }

//     // if (firebaseCoverPdfLink) {
//     //   lineProperties["Cover PDF"] = firebaseCoverPdfLink;
//     // }

//     // if (firebaseContentPdfLink) {
//     //   lineProperties["Content PDF"] = firebaseContentPdfLink;
//     // }

//     // const formData = buildFormData();

//     // Show loader
//     loader.style.display = "flex";

//     if (formData) {
//       fetch("https://api.laylbooks.com/books", {
//         method: "POST",
//         body: formData,
//       })
//         .then((res) => res.json())
//         .then((data) => {
//           console.log("Backend response:", data);
//           if (data.success && data.data?.pdfFileId) {
//             const pdfFileId = data.data.pdfFileId;
//             localStorage.setItem("backendPdfFileId", pdfFileId);
//             lineProperties["PDF File ID"] = pdfFileId;
//           }
//           proceedToCart();
//         })
//         .catch((err) => {
//           console.error("Backend upload error", err);
//           alert("There was an error uploading your photo. Please try again.");
//           loader.style.display = "none";
//         });
//     } else {
//       proceedToCart(); // fallback
//     }

//     function proceedToCart() {
//       const cartItems = [
//         {
//           id: selectedVariantId,
//           quantity: 1,
//           properties: lineProperties,
//         },
//       ];

//       if (isPhotoUploaded) {
//         cartItems.push({
//           id: photoAddonVariantId,
//           quantity: 1,
//           properties: {
//             _hidden: "Photo Upload Fee",
//           },
//         });
//       }

//       fetch("/cart/clear.js", { method: "POST" })
//         .then(() =>
//           fetch("/cart/add.js", {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({ items: cartItems }),
//           })
//         )
//         .then(() => {
//           // localStorage.removeItem("firebaseCoverPdfLink");
//           // localStorage.removeItem("firebaseContentPdfLink");
//           localStorage.removeItem("uploadedImageDataURL");
//           localStorage.removeItem("customPhoto");
//           localStorage.removeItem("backendPdfFileId");
//           localStorage.removeItem("photoUploaded");
//           window.location.href = "/cart";
//         })
//         .catch((error) => {
//           console.error("Error adding to cart", error);
//         })
//         .finally(() => {
//           loader.style.display = "none";
//         });
//     }
//   });
// });

document.addEventListener("DOMContentLoaded", async function () {
  const continueBtn = document.getElementById("continue-to-cart");
  const loader = document.getElementById("format-initial-loader");
  const errorElement = document.getElementById("api-error");

  const profile = await loadProfile();
  if(!profile){
    window.location.replace("/pages/personalise-book-bedtime");
    return;
  }

  function dataURLtoBlob(dataurl) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new Blob([u8arr], { type: mime });
  }

  async function buildFormData() {
    const selectedFormat = document.querySelector(
      'input[name="book-format"]:checked'
    ).value;
    const profile = await loadProfile();
    const selectedGender = profile?.gender;
    const childName = profile?.name;
    const customText = profile?.dedicationText;
    const dataURL = profile?.imageBase64;

    const formData = new FormData();
    formData.append("firstName", childName || "");
    formData.append("gender", (selectedGender || "BOY").toUpperCase());
    formData.append("bookType", "bedtime");
    formData.append("skinTone", profile?.skinTone === "dark" ? "dark" : "light");
    formData.append(
      "customText",
      customText ||
        "Dear [Name],\n\nThis book was made especially for you.\nMay your days be filled with laughter,\nyour heart be filled with kindness,\nand your nights be filled with peaceful sleep.\n\nWe love you very much.\n\nLove,\nMum & Dad"
    );
    formData.append(
      "coverType",
      selectedFormat === "premium" ? "HARD" : "SOFT"
    );
    if (dataURL) {
      const blob = dataURLtoBlob(dataURL);
      const imageFile = new File([blob], "photo.png", { type: "image/png" });
      formData.append("image", imageFile);
    }

    return formData;
  }

  continueBtn?.addEventListener("click", async function () {
    const selectedFormat = document.querySelector(
      'input[name="book-format"]:checked'
    ).value;
    const isPhotoUploaded = Boolean(profile?.imageBase64);

    const standardVariantId = 54388546961754;        // Bedtime: Standard book (soft)
    const premiumVariantId = 54388546994522;          // Bedtime: Premium cover (hard)
    const standardWithPhotoVariantId = 54388547027290; // Bedtime: Standard + photo
    const premiumWithPhotoVariantId = 54388547060058;  // Bedtime: Premium + photo

    const selectedVariantId =
      selectedFormat === "premium" ? (isPhotoUploaded ? premiumWithPhotoVariantId : premiumVariantId) : (isPhotoUploaded ? standardWithPhotoVariantId : standardVariantId);

    const symbol = Shopify.currency.active === 'USD' ? "$" : "£";
    
    let price;

    if (Shopify.currency.active === 'USD') {
      price = selectedFormat === "premium" ? "54.99" : "39.99";  // Fixed prices for USD
    } else {
      price = (Shopify.currency.rate * (selectedFormat === "premium" ? 39.99 : 29.99)).toFixed(2); // Default calculation for other currencies
    }

    const captalize = (word)=> word.slice(0,1).toUpperCase() + word.slice(1).toLowerCase();
    
    const lineProperties = {
      "Name": profile?.name || '',
      "Gender": captalize((profile?.gender || "").trim()),
      "Selected Format":
        selectedFormat === "premium"
            ? `Premium Cover (${symbol}${price})`
          : `Standard Book (${symbol}${price})`,
    };

    if (profile?.skinTone === "dark") {
      lineProperties["Character"] = "Dark skin tone";
    }

    if (isPhotoUploaded) {
      const price = Math.ceil(Shopify.currency.rate * 3).toFixed(2);
      lineProperties["Photo Upload"] = `Yes (+${symbol}${price})`;
    }


    // Lock + loader, backend (idempotent), cart add: see format-continue.js
    return laylSubmitBook({
      continueBtn,
      loader,
      errorElement,
      selectedFormat,
      selectedVariantId,
      lineProperties,
      buildFormData,
    });
  });
});
